import AddCircleIcon from "@mui/icons-material/AddCircle";
import DeleteIcon from "@mui/icons-material/Delete";
import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import BasicDatePicker from "../../components/Comman/DatePickerEx";
import { MyComponentWithIconProps } from "../../components/Comman/IconButton";
import { redColor } from "../../config/ColorObj";

const OutletTargetTable = ({
  rowList,
  handleRowChange,
  handleAddRow,
  handleDeleteRow,
  toMinDate,
  toMaxDate,
  formErrors,
  type,
}) => {
  return (
    <TableContainer component={Paper}>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell align="center">Sr. No.</TableCell>
            <TableCell align="center">From Date</TableCell>
            <TableCell align="center">To Date</TableCell>
            <TableCell align="center">Amount</TableCell>
            <TableCell align="center">Action</TableCell>{" "}
          </TableRow>
        </TableHead>
        <TableBody>
          {rowList.map((row, index) => (
            <TableRow key={row.index}>
              <TableCell width={"5%"} align="center">
                {row.index}
              </TableCell>
              <TableCell width={"10%"}>{row.frmDt}</TableCell>
              <TableCell width={"12%"}>
                <BasicDatePicker
                  color="primary"
                  name="toDt"
                  size="small"
                  value={row.toDt}
                  disabled={index !== rowList.length - 1}
                  fullWidth
                  onChange={(newDate) =>
                    handleRowChange(row.index, "toDt", newDate)
                  }
                  errorText={
                    formErrors[row.index]?.toDtError
                      ? formErrors[row.index].toDtError
                      : ""
                  }
                  isError={
                    formErrors[row.index]?.toDtError
                      ? formErrors[row.index]?.toDtError
                      : ""
                  }
                  minDate={toMinDate}
                  maxDate={toMaxDate}
                />
              </TableCell>
              <TableCell width={"10%"} align="center">
                <input
                  className={"customTextfield"}
                  placeHolder={"Amount"}
                  value={row.amount}
                  name="amount"
                  onChange={(e) =>
                    handleRowChange(row.index, "amount", e.target.value)
                  }
                  type="number"
                  step="0.01"
                  id="outletRate"
                />
                <span style={{ color: redColor, fontSize: "12px" }}>
                  {formErrors[row.index]?.amountError
                    ? formErrors[row.index].amountError
                    : ""}
                </span>
              </TableCell>
              <TableCell width={"12%"} align="center">
                {index === rowList.length - 1 && (
                  <MyComponentWithIconProps
                    statusImage={DeleteIcon}
                    color="error"
                    fontSize="medium"
                    title="Delete"
                    onClick={handleDeleteRow}
                  />
                )}

                {index === rowList.length - 1 &&
                  row.toDt?.format("DD-MM-YYYY") !==
                    toMaxDate?.format("DD-MM-YYYY") && (
                    <MyComponentWithIconProps
                      statusImage={AddCircleIcon}
                      color="primary"
                      fontSize="medium"
                      title="Add Row"
                      onClick={handleAddRow}
                    />
                  )}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default OutletTargetTable;
